import { DeliveryType, diff } from '@onbeefapp/constants';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCartStore } from '../../stores/cart';
import { useMerchantStore } from '../../stores/merchant';
import { useOrderDetails } from '../../stores/order-details';
import { ConfirmContinueOrderCheckout } from './ConfirmContinueOrderCheckout';

const OpenForOrdersModal: React.FC = () => {
  const { isClosedReason, isWithinBreak, schedules } = useMerchantStore(
    (state) => ({
      isClosedReason: state.isClosedReason,
      isWithinBreak: state.isWithinBreak,
      schedules: state.schedules,
    }),
  );

  const { deliveryType } = useOrderDetails();

  const { deliveryTime, withdrawalTime } = useCartStore((state) => ({
    deliveryTime: state.deliveryTime,
    withdrawalTime: state.withdrawalTime,
  }));

  const schedulingTime =
    deliveryType === DeliveryType.DELIVERY ? deliveryTime : withdrawalTime;

  const navigate = useNavigate();

  const back = () => {
    navigate(`/`);
  };

  const isScheduledForAnotherDay = React.useMemo(() => {
    if (!schedulingTime) return false;

    const deliveryDate = new Date(schedulingTime.date);
    const currentDate = new Date();

    deliveryDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);

    console.log(diff(deliveryDate, currentDate));
    return diff(deliveryDate, currentDate).days >= 0;
  }, [schedulingTime]);

  const canReceiveOrdersWhenClosed = schedules?.receive_orders_when_closed;

  if (!isClosedReason) return null;
  if (isWithinBreak && isScheduledForAnotherDay) return null;

  if (isWithinBreak) {
    return (
      <div>
        <ConfirmContinueOrderCheckout
          title={isClosedReason}
          showConfirmButton={true}
          textConfirmButton="Continuar"
          showCancelButton={false}
          onCancel={back}
        >
          <p>
            Você pode fazer o pedido normalmente. Assim que retornarmos às
            atividades, vamos atendê-lo o mais rápido possível.
          </p>
        </ConfirmContinueOrderCheckout>
      </div>
    );
  }
  return (
    <div>
      <ConfirmContinueOrderCheckout
        title="Loja Fechada"
        showConfirmButton={canReceiveOrdersWhenClosed}
        textConfirmButton="Continuar"
        showCancelButton={true}
        onCancel={back}
      >
        <p>
          {canReceiveOrdersWhenClosed
            ? isClosedReason
            : 'Loja fechada, aguarde até que esteja aberta.'}
        </p>
      </ConfirmContinueOrderCheckout>
    </div>
  );
};

export default OpenForOrdersModal;
